<p-contextMenu
    #contextMenu
    [model]="menuItems"
    styleClass="context-menu-styling"
    appendTo="body"
    (onHide)="onHide()"
></p-contextMenu>
